
require("./../../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import GiftReminderEmptyDashboard from 'components/pages/reminders/GiftReminderEmptyDashboard';
import GiftReminderItemModal from 'components/pages/reminders/GiftReminderItemModal';
import GiftReminderList from 'components/pages/reminders/GiftReminderList';
import GiftReminderNotification from 'components/pages/reminders/GiftReminderNotification';
import GiftReminderWrapper from 'components/pages/reminders/GiftReminderWrapper';
import { make as Container } from 'components/pages/myAccount/Container.bs';
import Spinner from 'components/Spinner';
import * as React from 'react';
import RemindersProvider, { useRemindersContext } from 'components/pages/reminders/context';
import { QueryClientProvider } from '@tanstack/react-query';
import client from 'api/client';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

export enum ModalState {
  New = 0,
  Edit = 1,
  Close = 2,
}

const Reminders = () => {
  const EmptyDashBoard = React.useCallback(() => {
    return <GiftReminderEmptyDashboard />;
  }, []);

  const Children = () => {
    const {
      remindersData = {
        count: 0,
        next: null,
        page_number: 1,
        page_size: 5,
        previous: null,
        results: [],
      },
      status,
    } = useRemindersContext();
    switch (status) {
      case 'success': {
        const data = {
          pageNumber: remindersData.page_number,
          pageSize: remindersData.page_size,
          count: remindersData.count,
          next: remindersData.next,
          previous: remindersData.previous,
          results: remindersData.results,
        };
        return Object.keys(remindersData.results).length === 0 ? (
          <EmptyDashBoard />
        ) : (
          <GiftReminderList
            count={data.count}
            currentPage={data.pageNumber}
            pageSize={data.pageSize}
            results={data.results}
          />
        );
      }
      case 'error':
        return <EmptyDashBoard />;
      case 'loading':
      default:
        return (
          <GiftReminderWrapper>
            <Spinner />
          </GiftReminderWrapper>
        );
    }
  };

  return (
    <QueryClientProvider client={client}>
      <Container>
        {() => {
          return (
            <RemindersProvider>
              <GiftReminderItemModal />
              <GiftReminderNotification />
              <Children />
            </RemindersProvider>
          );
        }}
      </Container>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};

export default Reminders;
